import { render, staticRenderFns } from "./delete-bank.vue?vue&type=template&id=48208afa&"
import script from "./delete-bank.vue?vue&type=script&lang=js&"
export * from "./delete-bank.vue?vue&type=script&lang=js&"
import style0 from "./delete-bank.vue?vue&type=style&index=0&id=48208afa&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports